import { render } from "./SettingFamily.vue?vue&type=template&id=3c2abe60&scoped=true&ts=true"
import script from "./SettingFamily.vue?vue&type=script&lang=ts"
export * from "./SettingFamily.vue?vue&type=script&lang=ts"

import "./SettingFamily.vue?vue&type=style&index=0&id=3c2abe60&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c2abe60"]])

export default __exports__